import { render, staticRenderFns } from "./Bilance.vue?vue&type=template&id=2f461d77&"
import script from "./Bilance.vue?vue&type=script&lang=js&"
export * from "./Bilance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports